import Activity from '../../models/activity'
import { toolIconTag, toolTypePath } from '~/common/define/toolType/toolTypePropsAttr'
import { fileIconTag, GeneralIconTag, IconTag } from '~/common/define/icon'
import { ToolTypeModel } from '~/models/tool'
import User from '~/models/user'
import { isAccessibleModel } from '~/common/define/access'
import { isAccessibleSpace } from '~/common/define/authority'

export const activityPath = (activity: Activity): string => {
  if (activity.system && !activity.service) {
    return null
  }
  if ((activity.tool || activity.file) && !activity.service && !activity.system) {
    return null
  }

  let path =
    (activity.organization ? ('/org/' + activity.organization.code) : '')
    + (activity.service ? ('/srv/' + activity.service.code) : '')
    + (activity.system ? ('/sys/' + activity.system.code) : '')

  if (activity.tool && activity.tool.type != ToolTypeModel.LINK) {
    path += `/${toolTypePath(activity.tool.type)}/` + activity.tool.key
  }

  if (activity.file) {
    path += '/file/' + activity.file.key
  }

  if (activity.news) {
    path += '/news/' + activity.news.key
  }

  return path
}

export const activitiesPath = (activities: Activity[], user: User): string => {
  let path = null
  activities.some((activity) => {
    if (!isAccessibleSpace(user, activity.organization, activity.service)) {
      return false
    }
    path = activityPath(activity)
    return !!path
  })
  return path
}

export const activityIconTag = (activity: Activity): IconTag => {
  if (activity.tool) {
    return toolIconTag(activity.tool.type)
  }
  if (activity.file) {
    return fileIconTag(activity.file)
  }
  if (activity.news) {
    return GeneralIconTag.PLANE
  }
  return null
}